import { render, staticRenderFns } from "./ComposeMail.vue?vue&type=template&id=ad460d12&scoped=true"
import script from "./ComposeMail.vue?vue&type=script&lang=js"
export * from "./ComposeMail.vue?vue&type=script&lang=js"
import style0 from "./ComposeMail.vue?vue&type=style&index=0&id=ad460d12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad460d12",
  null
  
)

export default component.exports